import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from '../tooltip';

import styles from './styles.css';

export default function RecentRatings({ ratings, numRatings, stationId }) {
  const getRatingBar = (index, rating = 'noData') => (
    <>
      <span id={`recent_ratings_${stationId}_${index}`} className={styles.ratingBarContainer}>
        <span className={`${styles.recentRatingLine} ${styles[rating]}`} />
      </span>
      <Tooltip size="sm" tootipContent={rating === 'noData' ? 'No Data' : rating} uniqueTargetSelector={`#recent_ratings_${stationId}_${index}`} />
    </>
  );

  return (
    <div className={styles.recentRatingsContainer}>
      {Array.from(Array(numRatings).keys()).map(index => getRatingBar(index, ratings[index]?.rating))}
    </div>
  );
}

RecentRatings.propTypes = {
  ratings: PropTypes.arrayOf(PropTypes.shape({
    rating: PropTypes.string,
  })),
  numRatings: PropTypes.number,
  stationId: PropTypes.number.isRequired,
};

RecentRatings.defaultProps = {
  ratings: [],
  numRatings: 5,
};
